import {testIds} from '@dms/routes';
import {DmsDataGrid} from '@dms/shared';

import {useBusinessCasesActionCallback} from '../../../hooks/useBusinessCasesActionCallback';

export function BusinessCaseListOS() {
  const [actionCallback] = useBusinessCasesActionCallback();

  return (
    <DmsDataGrid
      // It is not prepared on BE more: T20-50957
      gridCode="business-case-opensearch"
      actionCallback={actionCallback}
      data-testid={testIds.businessCase.home('bussinessCaseListOS')}
    />
  );
}
